export default function eventHandler() {
    // коллекция назначенных обработчиков
    const eventHandlers = {};

    // добавляем обработчик в коллекцию события
    function on(event, handler) {
        eventHandlers[event] = eventHandlers[event] || [];
        eventHandlers[event].push(handler);
    }

    // вызываем обработчики событиея
    function trigger(event, value) {
        if (eventHandlers[event]) {
            eventHandlers[event].map(handler => handler(value));
        }
    }

    return {
        on,
        trigger,
    };
}
